const emailRegExp = (): RegExp => {
  return new RegExp("^[a-zA-Z0-9_.+-Ññ]+@[a-zA-Z0-9-ñÑ]+\\.[a-zA-Z0-9-.]+$");
};

export default emailRegExp;
